import type { ComponentPropsWithoutRef } from 'react'
import cc from 'classcat'

export interface EditorLinkProps extends Omit<ComponentPropsWithoutRef<'a'>, 'type'> {
  readonly type?: 'external'
  readonly disabled?: boolean
}

export function EditorLink({
  type,
  target,
  disabled,
  className,
  children,
  href,
  rel,
  tabIndex,
  onClick,
  ...rest
}: EditorLinkProps) {
  const isExternal = type === 'external'
  const finalTarget = isExternal ? '_blank' : target
  // reverse-tabnabbing protection for any link that ends up opening in a new tab, not just type="external"
  const finalRel =
    finalTarget === '_blank'
      ? Array.from(new Set([...(rel?.split(/\s+/) ?? []), 'noopener', 'noreferrer'].filter(Boolean))).join(' ')
      : rel

  return (
    <a
      {...rest}
      href={href}
      target={finalTarget}
      rel={finalRel}
      aria-disabled={disabled || undefined}
      tabIndex={disabled ? -1 : tabIndex}
      onClick={(event) => {
        if (disabled) {
          event.preventDefault()
          event.stopPropagation()
          return
        }
        onClick?.(event)
      }}
      className={cc([className, 'link', { 'link-external': isExternal }])}
    >
      {children}
    </a>
  )
}
